import { Img, ImgProps } from '@chakra-ui/image';
import React from 'react';
import { useConfig } from '../hooks/useConfig';

export const Logo = (props: ImgProps) => {
  const config = useConfig();

  return <Img src={config?.logo.imgUrl} {...props} />;
};
